module.exports = __webpack_public_path__ + "static/img/霸王龙头骨.8760758.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/霸王龙头骨.png
// module id = 6UL2
// module chunks = 2